import createAPI from '../axios'

// 选修管理相关API
const externalTeacher = {
    externalTeacherInformation: {
        queryList: config => createAPI('/externalTeacher/externalTeacherInformation/queryList', 'post', config),
        save: config => createAPI('/externalTeacher/externalTeacherInformation/save', 'post', config),
        initOption: config => createAPI('/externalTeacher/externalTeacherInformation/initCombo', 'post', config),
        submit: config => createAPI('/externalTeacher/externalTeacherInformation/submit', 'post', config),
        del: config => createAPI('/externalTeacher/externalTeacherInformation/del', 'post', config),
        updateAuditState: config => createAPI('/externalTeacher/externalTeacherInformation/updateAuditState', 'post', config),
        deletefile: config => createAPI('/externalTeacher/externalTeacherInformation/deletefile', 'post', config),
        saveRec: config => createAPI('/externalTeacher/externalTeacherInformation/saveRec', 'post', config),
        queryRscList: config => createAPI('/externalTeacher/externalTeacherInformation/queryRscList', 'post', config),
        saveJobNumberRec: config => createAPI('/externalTeacher/externalTeacherInformation/saveJobNumberRec', 'post', config),
        noticeTeacher: config => createAPI('/externalTeacher/externalTeacherInformation/noticeTeacher', 'post', config),
    },
    workfile: {
        queryList: config => createAPI('/externalTeacher/workfile/queryList', 'post', config),
        queryDetailsList: config => createAPI('/externalTeacher/workfile/queryDetailsList', 'post', config),
        save: config => createAPI('/externalTeacher/workfile/save', 'post', config),
    },
    externalTeacherInfo: {
        queryList: config => createAPI('/externalTeacher/externalTeacherInfo/queryList', 'post', config),
        save: config => createAPI('/externalTeacher/externalTeacherInfo/save', 'post', config),
        deleteById: config => createAPI('/externalTeacher/externalTeacherInfo/deleteById', 'post', config),
        generateZh: config => createAPI('/externalTeacher/externalTeacherInfo/generateZh', 'post', config),
        drzhwpjs: config => createAPI('/externalTeacher/externalTeacherInfo/drzhwpjs', 'post', config),
        batchExport: config => createAPI('/externalTeacher/externalTeacherInfo/batchExport', 'post', config),
    },
};

export default externalTeacher;



// WEBPACK FOOTER //
// ./src/api/modules/externalTeacher.js